import {h, Fragment} from "preact"
import { AutocompleteElement, useCurrencyFormatting } from "@nosto/preact";
import { useState, useMemo, useRef, useEffect } from "preact/hooks";
import { productImagePlaceholder, getSrcset } from "../helpers"

export default function DropdownProduct({ product }) {
    const { format } = useCurrencyFormatting();
    const tags = [
        product.onSale
            ? {
                  label: "Sale",
                  class: "ns-badge ns-badge-green-outline ns-d-inline-block ns-text-align-center"
              }
            : undefined
    ].filter(v => !!v)

    const isOnDiscount = product?.listPrice > product?.price;
    const discountPercentage = useMemo(() => {
        return Math.round(((product.listPrice - product.price) / product.listPrice) * 100);
    }, [product?.listPrice, product?.price]);
    const isMoreThanOneVariant = product?.skus && product?.skus?.length > 1;
    

    const openerRef = useRef(null);
    const modalId = `QuickAdd-${product?.productId}`;

    useEffect(() => {
        const tryInitialize = () => {
        const opener = openerRef.current;
        const modal = document.getElementById(modalId);

        if (opener && modal) {
            // Force <modal-opener> to reinitialize
            const clone = opener.cloneNode(true);
            opener.replaceWith(clone);
        } else {
            requestAnimationFrame(tryInitialize);
        }
        };

        tryInitialize();
    }, [product]);

    const handle = product?.url?.split("/")?.pop();

    return (
        <li class="grid__item">
            <AutocompleteElement key={product?.productId} hit={product}>
                <div
                    data-url={product?.url}
                    class="ns-d-flex flex-row ns-clickable ns-markets"
                    data-nosto-element="product"
                    data-handle={handle}
                >
                    {/* <nosto-dynamic-card handle={handle} template="card">
                        <div class="product-card-skeleton"></div>
                    </nosto-dynamic-card> */}

                    <div class="card-wrapper product-card-wrapper underline-links-hover">
                        <div class="
                            card card--standard
                            card--media
                            " style="--ratio-percent: 100%;">
                            <div class="card__inner color-scheme-2 gradient ratio" style="--ratio-percent: 100%;">
                                <div class="card__media">
                                    <div class="media media--transparent media--hover-effect">
                                        <img srcSet={getSrcset(product?.imageUrl)} src={`${product?.imageUrl}&width=533`} sizes="(min-width: 1400px) 317px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)" alt={product?.name} class="motion-reduce" loading="lazy" width="1800" height="1800" />
                                    </div>
                                </div>
                                <div class="card__content">
                                    <div class="card__information">
                                        <h3 class="card__heading">
                                            <a href={product?.url} id={`StandardCardNoMediaLink-template--19903175131362__product-grid-${product?.productId}`} class="full-unstyled-link ns-link" aria-labelledby={`StandardCardNoMediaLink-template--19903175131362__product-grid-${product?.productId} NoMediaStandardBadge-template--19903175131362__product-grid-${product?.productId}`}>
                                                {product?.name}
                                            </a>
                                        </h3>
                                    </div>
                                    <div class="card__badge">
                                        {isOnDiscount && <span id={`NoMediaStandardBadge-template--19903175131362__product-grid-${product?.productId}`} class="badge badge--top-right color-scheme-9ab99e21-2a3e-4c77-b7cc-cac6e4ee760a">
                                        {discountPercentage}% OFF
                                        </span>}
                                    </div>
                                </div>
                            </div>
                            <div class="card__content">
                                <div class="card__information">
                                <span class="visually-hidden">Vendor:</span>
                                <h3 class="card__heading ns-text-two-lines" style={{overflow:"hidden"}}>{product?.name}</h3>
                                <div class="caption-with-letter-spacing light  h5" id={`title-template--19903175131362__product-grid-${product?.productId}`}>
                                    <a href={product?.url} id={`CardLink-template--19903175131362__product-grid-${product?.productId}`} class="full-unstyled-link ns-link" aria-labelledby={`CardLink-template--19903175131362__product-grid-${product?.productId} Badge-template--19903175131362__product-grid-${product?.productId}`}
                                    style={{textTransform:"capitalize"}}
                                    >
                                    {product?.brand}
                                    </a>
                                </div>
                                <div class="card-information">
                                    <span class="caption-large light"></span>
                                    <div class={`price ${isOnDiscount ? 'price--on-sale' : ''}`}>
                                        <div class="price__container">
                                            {!isOnDiscount ? (
                                                <div class="price__regular">
                                                <span class="visually-hidden visually-hidden--inline">Regular price</span>
                                                <span class="price-item price-item--regular ns-price">
                                                    {format(product?.price)}
                                                </span>
                                            </div>
                                            ) : (
                                                <div class="price__sale">
                                                <span class="visually-hidden visually-hidden--inline">Regular price</span>
                                                <span class="price-item price-item--sale price-item--last ns-price">
                                                    {format(product?.price)}
                                                </span>
                                                <span>
                                                    <s class="price-item price-item--regular ns-list-price">
                                                    {format(product?.listPrice)}
                                                    </s>
                                                </span>
                                                <span class="visually-hidden visually-hidden--inline">Sale price</span>
                                            </div>
                                            )}
                                            <small class="unit-price caption hidden">
                                                <span class="visually-hidden">Unit price</span>
                                                <span class="price-item price-item--last">
                                                <span></span>
                                                <span aria-hidden="true">/</span>
                                                <span class="visually-hidden">&nbsp;per&nbsp;</span>
                                                <span>
                                                </span>
                                                </span>
                                            </small>
                                        </div>
                                    </div>
                                </div>
                                </div>
                                <div 
                                    class="quick-add no-js-hidden"
                                    ref={openerRef}
                                    dangerouslySetInnerHTML={{__html: isMoreThanOneVariant ? `
                                        <modal-opener data-modal="#${modalId}">
                                            <button id="quick-add-${product?.productId}-submit" name="add" type="submit" class="quick-add__submit button button--full-width button--secondary" aria-haspopup="dialog" aria-labelledby="quick-add-${product?.productId}-submit title-${product?.productId}" data-product-url="${product?.url}">
                                                Choose options
                                                <link href="//haveda.com/cdn/shop/t/499/assets/component-loading-spinner.css?v=116724955567955766481757448028" rel="stylesheet" type="text/css" media="all" />
                                                <div class="loading__spinner hidden">
                                                    <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                                                        <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                                                    </svg>
                                                </div>
                                            </button>
                                        </modal-opener>
                                    ` : `
                                        <product-form data-section-id="template--19903175131362__product-grid">
                                            <form method="post" action="/cart/add" id="quick-add-${product?.productId}" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
                                                <input type="hidden" name="form_type" value="product" />
                                                <input type="hidden" name="utf8" value="✓" />
                                                <input type="hidden" name="id" value="${product?.skus[0]?.id}" class="product-variant-id" />
                                                <button id="quick-add-${product?.productId}-submit" type="submit" name="add" class="quick-add__submit button button--full-width button--secondary" aria-haspopup="dialog" aria-labelledby="quick-add-${product?.productId}-submit title-${product?.productId}" aria-live="polite" data-sold-out-message="true">
                                                    <span>ADD TO BAG
                                                    </span>
                                                    <span class="sold-out-message hidden">
                                                    COMING SOON
                                                    </span>
                                                    <link href="//haveda.com/cdn/shop/t/499/assets/component-loading-spinner.css?v=116724955567955766481757448028" rel="stylesheet" type="text/css" media="all" />
                                                    <div class="loading__spinner hidden">
                                                    <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                                                        <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                                                    </svg>
                                                    </div>
                                                </button>
                                                <input type="hidden" name="product-id" value=${product?.productId} />
                                                <input type="hidden" name="section-id" value="template--19903175131362__product-grid" />
                                            </form>
                                        </product-form>`}}>
                                </div>
                                <div class="card__badge">
                                    <span id={`Badge-template--19903175131362__product-grid-${product?.productId}`} class="badge badge--top-right color-scheme-9ab99e21-2a3e-4c77-b7cc-cac6e4ee760a">
                                        {discountPercentage}% OFF
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </AutocompleteElement>
        </li>
    );

}